module.exports = __webpack_public_path__ + "media/images/smart_phone/ttl_mie-a139601dbfa8379e33e955d71ffe9f5e.png";